import { Component, forwardRef, Inject, Injector, Optional, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { IpAddressService } from '@common/services';
import { InputBase } from '@ui/components/form/base/input-base';

@Component({
    selector: 'aa-input-ipv4',
    templateUrl: './input-ip.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputIpv4Component),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => InputIpv4Component),
            multi: true,
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputIpv4Component extends InputBase<string>
{
    private static identifier: number = 0;

    constructor(
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        private ipAddressService: IpAddressService,
        injector: Injector
    )
    {
        super(injector);

        this.fieldId = `id-input-ipv4-${InputIpv4Component.identifier++}`;
    }

    validate ({ value }: UntypedFormControl)
    {
        return this.ipAddressService.validateIpv4Address(value);
    }
}
